<template>
  <div class="empty-screen">
    <img :src="iconImage">
    <text-string v-if="textString"
                 :label-id="textString"
                 class="text-center"/>
    <slot></slot>
  </div>
</template>

<script>
  import Ico044 from '@/assets/images/empty-states/ico044.svg';
  import Ico051 from '@/assets/images/empty-states/ico051.svg';
  import Ico052 from '@/assets/images/empty-states/ico052.svg';

  export default {
    name: 'empty-screen',
    props: {
      icon: {type: String, required: true},
      iconSize: {type: String, default: '180px'},
      textString: {type: String},
    },
    computed: {
      iconImage() {
        return {
          'ns-icon-ico044': Ico044,
          'ns-icon-ico051': Ico051,
          'ns-icon-ico052': Ico052,
        }[this.icon];
      },
    },
  }
</script>

<style lang="scss">
  .empty-screen {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;

    img {
      display: block;
      margin: auto;
    }

    span {
      height: unset !important;
      background: none !important;
    }
  }
</style>
